import Error404 from 'App/pages/404'
import Error500 from 'App/pages/500'
import Login from './login'
import Logout from './logout'
import OIDC from './oidc'
import Lockscreen from 'App/pages/lockscreen'

export default [Error404, Error500, Login, Logout, OIDC, Lockscreen]
